/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */

import React from "react";
import {
  getMenuParentElements,
  getParentMenuChildren,
  toggleCookieSettings,
} from "../../menuHelpers";
import MuotolevyDesktopMenu from "./MuotolevyDesktopMenu";
import SideNav from "./SideNav";

// Desktop menu
export const DesktopMenu = (props) => {
  const { datalinks, parentMenu, sitemegamenu, sitemegamenumuotolevy } = props;
  
  // Null check for parentMenu
  if (!parentMenu) return null;
  
  const { menuChildren, menuChildrenWithChildren, menuHasNoGrandChildren } =
    getParentMenuChildren(
      sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
      parentMenu.ID,
    );
  if (menuChildren.length === 0) return null;
  const [muotolevyParentMenu] = getMenuParentElements(sitemegamenumuotolevy);
  // NOTE: if muotolevy menu is active, render muotolevy menu
  if (muotolevyParentMenu && parentMenu.ID === muotolevyParentMenu.ID) {
    return (
      <MuotolevyDesktopMenu sitemegamenumuotolevy={sitemegamenumuotolevy} />
    );
  }
  return (
    <div className="bg-white shadow-lg">
      <div className="w-full px-16 pt-8 pb-0 max-h-[80vh] overflow-auto mt-4">
        <div className="grid grid-cols-12 gap-16">
          <div className="col-span-8">
            <div className="grid gap-8 w-full">
              <ul className="w-full pl-0">
                <li className="text-muotolevy-red transition-all duration-200 border-b-2 border-muotolevy-red hover:border-muotolevy-yellow block py-4 pb-2">
                  <a
                    role={parentMenu.url.startsWith("http") ? "link" : "button"}
                    href={parentMenu.url}
                    className="text-muotolevy-red hover:text-muotolevy-yellow hover:no-underline text-base"
                  >
                    {parentMenu.title}
                  </a>
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-2 gap-8 w-full">
              {!menuHasNoGrandChildren && (
                <div>
                  <ul className="pl-0">
                    {menuChildrenWithChildren.map((item) => (
                      <li key={item.ID} className="block border-b-0 py-4 pb-2">
                        <span className="font-bold text-base text-muotolevy-red mb-2 uppercase">
                          {item.title}
                        </span>
                        {item.children && (
                          <ul className="pl-0">
                            {item.children.map((child) => (
                              <li
                                key={child.ID}
                                className="block border-b-0 py-4 pb-2 font-bold"
                              >
                                <a 
                                  href={child.url}
                                  className="text-base text-text-gray hover:text-muotolevy-yellow hover:no-underline"
                                >
                                  {child.title}
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div>
                <ul className="pl-0">
                  {menuChildren.map((item) => (
                    <li key={item.ID} className="block border-b-0 py-4 pb-2">
                      <a 
                        href={item.url}
                        className="text-base text-text-gray hover:text-muotolevy-yellow hover:no-underline"
                      >
                        {item.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-span-4 flex">
            <SideNav {...props} />
          </div>
        </div>
        <div className="grid gap-16">
          <div className="flex-1">
            <div className="py-4">
              {datalinks && (
                <ul className="pl-0">
                  {datalinks.map((item, index, array) =>
                    index === array.length - 1 ? (
                      <li key={item.url || index} className="inline-block mx-4 first:mx-0 first:mr-4 border-b-0">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleCookieSettings();
                          }}
                          className="text-sm text-gray-500 hover:text-text-gray hover:no-underline"
                        >
                          {item.title}
                        </a>
                      </li>
                    ) : (
                      <li key={item.url || index} className="inline-block mx-4 first:mx-0 first:mr-4 border-b-0">
                        <a 
                          href={item.url}
                          className="text-sm text-gray-500 hover:text-text-gray hover:no-underline"
                        >
                          {item.title}
                        </a>
                      </li>
                    ),
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopMenu;
